import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics';
import TelemetryService from '../TelemetryService';

export default class FirebaseTelemetryService extends TelemetryService {

    constructor(userProperties)
    {
        super();

        setUserProperties(getAnalytics(), userProperties);
        this._enabled = true;
    }

    reportEvent(event, properties) {
        if(this._enabled){
            logEvent(getAnalytics(), event, properties);
        }
    }
}